import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Iteration = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Iteration' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,9 L1,23 L15,23 M5,5 L5,19 L19,19 M9,15 L23,15 L23,1 L9,1 L9,15 L9,15 L9,15 Z' />
  </StyledIcon>
);
